import { router } from '@/router';

import { setStore, getStore, removeStore } from '@/lib/localStore';

export const handleVersion = () => {
  const v = getStore({
    name: 'HOME_VERSION',
  });

  if (v == 'v2') {
    return '/v2';
  }
  return '/';
};

export const getVersion = () => {
  return getStore({
    name: 'HOME_VERSION',
  });
};

export const gotoNew = () => {
  setStore({
    name: 'HOME_VERSION',
    content: 'v2',
  });
  router.replace('/v2');
};

export const gotoOld = () => {
  setStore({
    name: 'HOME_VERSION',
    content: '/',
  });
  router.replace('/');
};
